import { decode as base64_decode, encode as base64_encode } from "base-64";
import { message } from "antd";
import config from "../config";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class OverSpeedDurationReportStore {
  overspeedData = [];
  total = 0;
  loading = false;
  rootStore;
  remaning_vehicleId = "";
  last_record_timestamp = "";
  pythonReportMessage = false;
  pythonReportErrorMessage = false;
  constructor(rootStore) {
    makeObservable(this, {
      overspeedData: observable,
      total: observable,
      loading: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      pythonReportMessage: observable,
      pythonReportErrorMessage: observable,

      loadData: action,
      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    offset,
    limit,
    vehicleId,
    fromDate,
    toDate,
    interval,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      interval: interval,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    if (config.pythonReport === 1) {
      if (offset === 0) {
        postData.last_record_timestamp = "";
        postData.remaning_vehicleId = "";
      } else {
        postData.last_record_timestamp = this.last_record_timestamp;
        postData.remaning_vehicleId = this.remaning_vehicleId;
      }
      var response = await postApi
        .getClient()
        .post("/tracking_report/overspeed", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=overspeed", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId;
    }

    this.overspeedData = response?.data?.data?.overspeed;
    this.loading = false;
  }
  async exportExcel(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };

      try {
        const res = await postApi
          .getClient("report")
          .post("/tracking_report/overspeed/download/excel", getData, {
            responseType: "blob",
          });

        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicleidle&a=exportidleexcel&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }

  async exportpdf(getData) {
    if (config.pythonReport === 1) {
      getData = { ...getData, language: "english" };

      try {
        await postApi
          .getClient("report")
          .post("/tracking_report/overspeed/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
        message.error("Failed to download the report. Please try again.");
      }
    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=vehicleidle&a=exportidlepdf&cid=" +
        getData.companyId +
        "&userId=" +
        getData.userId +
        "&vid=" +
        getData.vehicleId +
        "&int=" +
        getData.interval +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }
  }
}

export default OverSpeedDurationReportStore;
